
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Refresh = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M13.81,9.8l6.5-.2.1-6.5L18.91,3l-.15,3.87A9.05,9.05,0,1,0,10.11,21.8a13.55,13.55,0,0,0,2,.2,9.23,9.23,0,0,0,4.8-1.4l.6-.4-.8-1.3-.6.4a7.92,7.92,0,0,1-5.8,1A7,7,0,0,1,5.61,17,7.69,7.69,0,0,1,8,6.5a7.69,7.69,0,0,1,9.85,1.55l-4.15.25Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

Refresh.defaultProps = {
  title: 'Refresh',
};

export default Refresh;
